import { createContext } from "react";

import { IGatewaysContext } from "./gateways-context.inteface";

export const GatewaysContext = createContext<IGatewaysContext>(
  {} as IGatewaysContext
);
